export default __webpack_public_path__ + "static/media/misc-bathtubA-768w.c27c6817.avif";